
import React, { useState, useContext, useEffect } from 'react'
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardFooter,
	Col,
	Collapse,
	Container,
	Form,
	FormGroup,
	Input,
	Label,
	ListGroup,
	ListGroupItem,
	Modal,
	Row
} from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'

import PageTitleContextMenu from '../../components/PageTitles/PageTitleContextMenu'
import AuctionTemplatesService from '../../services/AuctionTemplatesService'
import SiteService from '../../services/SiteService'
import { TemplatesContext } from '../../contexts/TemplatesProvider'
import { SessionContext } from '../../contexts/SessionProvider'
import Enumeration from '../../enumeration'
import SelectExternalUserModalRedux from '../../components/Modals/SelectExternalUserModalRedux'
import { subscribe, trigger, unsubscribe } from '../../events/customEvents'
import SelectDealerUserModalRedux from '../../components/Modals/SelectDealerUserModalRedux'

const AuctionTemplateDetail = () =>
{
	const [isBusy, setIsBusy] = useState(false)
	const { t } = useTranslation()
	const templatesContext = useContext(TemplatesContext)
	const [openedTierCollapse, setOpenedTierCollapse] = useState([])
	const [activeTier, setActiveTier] = useState(undefined)
	const [activeTierMembers, setActiveTierMembers] = useState(undefined)
	const [showExternalUserModal, setShowExternalUserModal] = useState(false)
	const [exclusionList, setExclusionList] = useState([])
	const [showDealerUserModal, setShowDealerUserModal] = useState(false)
	const [templateSubmitted, setTemplateSubmitted] = useState(false)
	const sessionContext = useContext(SessionContext)
	const [auctionTierStates, setAuctionTierStates] = useState([])
	const [auctionTierTypes, setAuctionTierTypes] = useState([])
	const [emailTemplates, setEmailTemplates] = useState([])
	const [defaultSourceTypes, setDefaultSourceTypes] = useState([])
	const [oems, setOems] = useState([])
	const navigate = useNavigate()
	const [openConfirmTemplateDeleteModal, setOpenConfirmTemplateDeleteModal] = useState(false)
	const [openMissingTierTypeModal, setOpenMissingTierTypeModal] = useState(false)
	
	useEffect(() =>
	{
		initializeValidation()
		
		subscribe('selectExternalUserModalClosed', handleSelectExternalUserModalClosed)
		subscribe('selectDealerUserModalClosed', handleSelectDealerUserModalClosed)
		
		retrieveTemplateViewModel()
	}, [])
	
	useEffect(() =>
	{
		return function cleanup()
		{
			unsubscribe('selectExternalUserModalClosed', handleSelectExternalUserModalClosed)
			unsubscribe('selectDealerUserModalClosed', handleSelectDealerUserModalClosed)
		}
	}, [])
	
	const retrieveTemplateViewModel = () =>
	{
		setIsBusy(true)
		AuctionTemplatesService
			.getAuctionTemplateViewModel(sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				setAuctionTierStates(result.data.actionResult.tierStates)
				setDefaultSourceTypes(result.data.actionResult.defaultSourceTypes)
				setOems(result.data.actionResult.oems)
				setAuctionTierTypes(result.data.actionResult.tierTypes)
				
				const _emailTemplates = []
				_emailTemplates.push({ emailTemplateId: null, templateName: '-- Select --' })
				result.data.actionResult.emailTemplates.map((emailTemplate) =>
				{
					_emailTemplates.push(emailTemplate)
				})
				setEmailTemplates(_emailTemplates)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const initializeValidation = () =>
	{
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const _validation =
				{
					validation:
						{
							name: (previousTemplate.name !== undefined && previousTemplate.name.length > 0),
							settlementPeriodHours: (previousTemplate.settlementPeriodHours !== undefined && previousTemplate.settlementPeriodHours > 0)
						}
				}
			
			let currentTemplate = { ...previousTemplate }
			currentTemplate = {
				...currentTemplate,
				..._validation
			}
			let _auctionTiers = []
			currentTemplate.auctionTemplateTiers.forEach((auctionTemplateTier) =>
			{
				const _tierValidation = { validation: { name: false, activeDurationHours: false } }
				_auctionTiers.push({
					...auctionTemplateTier,
					..._tierValidation
				})
			})
			currentTemplate.auctionTemplateTiers = _auctionTiers
			return currentTemplate
		})
	}
	
	const handleSelectDealerUserModalClosed = (event) =>
	{
		setShowDealerUserModal(false)
		handleUpdateTierMembers({...event.detail})
	}
	
	const handleSelectExternalUserModalClosed = (event) =>
	{
		setShowExternalUserModal(false)
		if (event.detail.activeTierMembers)
		{
			handleUpdateTierMembers({...event.detail})
		}
	}
	
	const handleUpdateTierMembers = (eventDetail) =>
	{
		eventDetail.activeTierMembers.forEach((activeTierMember) =>
		{
			activeTierMember.adminAuctionTierId = eventDetail.tierId
			activeTierMember.tierId = eventDetail.tierId
		})
		
		setActiveTierMembers(([...eventDetail.activeTierMembers]))
		
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			try
			{
				const currentTemplate = { ...previousTemplate }
				
				let auctionTemplateTier = currentTemplate.auctionTemplateTiers.find(templateTier => { return templateTier.adminAuctionTierId === eventDetail.tierId })
				if (auctionTemplateTier)
				{
					auctionTemplateTier.auctionTemplateTierMembers = [...eventDetail.activeTierMembers]
				}
				
				return currentTemplate
			}
			catch {}
		})
	}
	
	const handleTemplatePropertyChange = (e) =>
	{
		const { name, value} = e.target
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			currentTemplate[name] = value
			return currentTemplate
		})
	}
	
	const handleDisabledCheckboxChange = (disabled) =>
	{
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			currentTemplate.disabled = !disabled
			return currentTemplate
		})
	}
	
	const toggleTierCollapse = (tierIndexPosition) =>
	{
		if (openedTierCollapse.includes(tierIndexPosition))
		{
			setOpenedTierCollapse([])
			setActiveTierMembers(undefined)
		}
		else
		{
			setOpenedTierCollapse([tierIndexPosition])
			
			const auctionTier = templatesContext.auctionTemplate.auctionTemplateTiers.find(templateTier => { return templateTier.tierIndexPosition === tierIndexPosition })
			setActiveTier(auctionTier)
			setActiveTierMembers(auctionTier.auctionTemplateTierMembers)
		}
	}
	
	const handleCreateNewTier = () =>
	{
		let nextAdminAuctionTierId = 1
		
		if (templatesContext.auctionTemplate.auctionTemplateTiers.length > 0)
		{
			const adminAuctionTier = templatesContext.auctionTemplate.auctionTemplateTiers.reduce((prev, current) => (prev && prev.adminAuctionTierId > current.adminAuctionTierId) ? prev : current)
			nextAdminAuctionTierId = adminAuctionTier.adminAuctionTierId + 1
		}
		
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			
			const newTemplateTier =
				{
					adminAuctionTierId: nextAdminAuctionTierId,
					adminAuctionId: currentTemplate.adminAuctionId,
					name: 'New Auction Template Tier',
					tierIndexPosition: currentTemplate.auctionTemplateTiers.length,
					activeDurationHours: Enumeration.DefaultTierDurationHours,
					auctionTierStateId: Enumeration.AuctionTierStates.New,
					auctionTemplateTierMembers: [],
					isNew: true,
					auctionTierTypeId: Enumeration.AuctionTierTypes.BiddingTier,
					validation: { name: false, activeDurationHours: false }
				}
			currentTemplate.auctionTemplateTiers.push(newTemplateTier)
			
			setOpenedTierCollapse([newTemplateTier.tierIndexPosition])
			setActiveTier(newTemplateTier)
			setActiveTierMembers( newTemplateTier.auctionTemplateTierMembers)
			
			return currentTemplate
		})
	}
	
	const handleTemplateTierPropertyChange = (e, adminAuctionTierId) =>
	{
		const { name, value} = e.target
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			const adminAuctionTier = currentTemplate.auctionTemplateTiers.find((auctionTemplateTier) => auctionTemplateTier.adminAuctionTierId === adminAuctionTierId)
			adminAuctionTier[name] = value
			return currentTemplate
		})
	}
	
	const handleMoveTierUp = (auctionTemplateTier) =>
	{
		const auctionTemplateTiers = templatesContext.auctionTemplate.auctionTemplateTiers
		
		const lowerIndexAuctionTier = auctionTemplateTiers.find(templateTier => { return templateTier.tierIndexPosition === (auctionTemplateTier.tierIndexPosition - 1) })
		lowerIndexAuctionTier.tierIndexPosition++
		auctionTemplateTier.tierIndexPosition--
		
		auctionTemplateTiers.sort((a, b) => (a.tierIndexPosition > b.tierIndexPosition) ? 1 : -1)
		
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			currentTemplate.auctionTemplateTiers = auctionTemplateTiers
			return currentTemplate
		})
	}
	
	const handleMoveTierDown = (auctionTemplateTier) =>
	{
		const auctionTemplateTiers = templatesContext.auctionTemplate.auctionTemplateTiers
		
		const higherIndexAuctionTier = auctionTemplateTiers.find(templateTier => { return templateTier.tierIndexPosition === (auctionTemplateTier.tierIndexPosition + 1) })
		higherIndexAuctionTier.tierIndexPosition--
		auctionTemplateTier.tierIndexPosition++
		
		auctionTemplateTiers.sort((a, b) => (a.tierIndexPosition > b.tierIndexPosition) ? 1 : -1)
		
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			currentTemplate.auctionTemplateTiers = auctionTemplateTiers
			return currentTemplate
		})
	}
	
	const handleRemoveTier = (auctionTemplateTier) =>
	{
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			
			setActiveTierMembers(undefined)
			currentTemplate.auctionTemplateTiers = currentTemplate.auctionTemplateTiers.filter((templateTier) => { return templateTier.adminAuctionTierId !== auctionTemplateTier.adminAuctionTierId })
			
			return currentTemplate
		})
	}
	
	const handleAddExternalUser = () =>
	{
		const exclusionList = activeTierMembers.map(tierMember => { return tierMember.entityId })
		setExclusionList(exclusionList)
		setShowExternalUserModal(true)
	}
	
	const handleRemoveTierMember = (activeTierMember) =>
	{
		let currentTierMembers = []
		setActiveTierMembers((previousTierMembers) =>
		{
			currentTierMembers = [ ...previousTierMembers ]
			currentTierMembers = currentTierMembers.filter((tierMember) => { return tierMember.tierMemberId !== activeTierMember.tierMemberId })
			
			return currentTierMembers
		})
		
		templatesContext.setAuctionTemplate((previousTemplate) =>
		{
			const currentTemplate = { ...previousTemplate }
			
			currentTemplate.auctionTemplateTiers.find(templateTier => { return templateTier.adminAuctionTierId === activeTierMember.tierId }).auctionTemplateTierMembers = currentTierMembers
			
			return currentTemplate
		})
	}
	
	const handleAddDealerUser = () =>
	{
		const exclusionList = activeTierMembers.map(tierMember => { return tierMember.entityId })
		setExclusionList(exclusionList)
		setShowDealerUserModal(true)
	}
	
	const isValidTemplate = () =>
	{
		let templateValid = false
		
		let templateNameValid = templatesContext.auctionTemplate.validation.name = (templatesContext.auctionTemplate.name !== undefined && templatesContext.auctionTemplate.name.length > 0)
		let templateSettlementPeriodValid = templatesContext.auctionTemplate.validation.settlementPeriodHours = (templatesContext.auctionTemplate.settlementPeriodHours !== undefined && templatesContext.auctionTemplate.settlementPeriodHours > 0)
		
		templateValid = (templateNameValid && templateSettlementPeriodValid)
		
		templatesContext.auctionTemplate.auctionTemplateTiers.forEach((templateTier) =>
		{
			templateTier.validation.name = templateTier.name.length > 0
			templateTier.validation.activeDurationHours = !isNaN(templateTier.activeDurationHours) && parseInt(templateTier.activeDurationHours) > 0
		})
		let tiersValid = templatesContext.auctionTemplate.auctionTemplateTiers.every((tier) => tier.validation.name && tier.validation.activeDurationHours)
		
		return templateValid && tiersValid
	}
	
	const hasSuggestedTierTypes = () =>
	{
		const mbpTier = templatesContext.auctionTemplate.auctionTemplateTiers.find((templateTier) => parseInt(templateTier.auctionTierTypeId) === Enumeration.AuctionTierTypes.MBPTier)
		const hasMbpTier = mbpTier !== undefined
		
		const originalDealerTier = templatesContext.auctionTemplate.auctionTemplateTiers.find((templateTier) => parseInt(templateTier.auctionTierTypeId) === Enumeration.AuctionTierTypes.OriginalDealerTier)
		const hasOriginalDealerTier = originalDealerTier !== undefined
		
		return hasMbpTier && hasOriginalDealerTier
	}
	
	const handleSaveTemplate = () =>
	{
		setTemplateSubmitted(true)
		
		if (isValidTemplate())
		{
			if (hasSuggestedTierTypes())
			{
				finallySaveTemplate()
			}
			else
			{
				acknowledgeMissingTierType()
			}
		}
		else
		{
			SiteService.displayApiError({ message: 'Invalid input. The template or template tier input is invalid.' })
		}
	}
	
	const acknowledgeMissingTierType = () =>
	{
		setOpenMissingTierTypeModal(true)
	}
	
	const finallySaveTemplate = () =>
	{
		setOpenMissingTierTypeModal(false)
		if (templatesContext.auctionTemplate.adminAuctionId !== 0)
		{
			modifyTemplate()
		}
		else
		{
			addTemplate()
		}
	}
	
	const addTemplate = () =>
	{
		setIsBusy(true)
		AuctionTemplatesService
			.addTemplate(templatesContext.auctionTemplate, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', { title: 'Update Success', message: 'The auction template was updated.', type: 'success', duration: 5 })
				navigate('/secure/auction-templates-listing')
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const modifyTemplate = () =>
	{
		setIsBusy(true)
		AuctionTemplatesService
			.modifyTemplate(templatesContext.auctionTemplate, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				trigger('raiseNotification', { title: 'Update Success', message: 'The auction template was updated.', type: 'success', duration: 5 })
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleConfirmTemplateDelete = () =>
	{
		setOpenConfirmTemplateDeleteModal(true)
	}
	
	const handleDeleteTemplate = () =>
	{
		setOpenConfirmTemplateDeleteModal(true)
		
		setIsBusy(true)
		AuctionTemplatesService
			.deleteTemplate(templatesContext.auctionTemplate.adminAuctionId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				templatesContext.setAuctionTemplate({
					adminAuctionId: 0,
					name: '',
					createdByUserId: 0,
					createdDate: undefined,
					userName: '',
					defaultForTypeId: 1,
					defaultForEntityId: undefined,
					auctionTemplateTiers: []
				})
				
				trigger('raiseNotification', { title: 'Delete Success', message: 'The auction template was deleted.', type: 'success', duration: 5 })
				navigate('/secure/auction-templates-listing')
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleGoBack = () =>
	{
		navigate('/secure/auction-templates-listing')
	}
	
	return (
		<>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
				style={{ zIndex: 10000000, position: 'fixed' }}
			/>
			<PageTitleContextMenu
				heading={ t('Templates.AuctionDetail.Title') }
				subheading=""
				icon="pe-7s-map-2 icon-gradient bg-premium-dark"
				headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
			/>
			<Container className="mt--6" fluid>
				<Row>
					<div className="col">
						<Form role="form">
							<Card>
								<CardHeader></CardHeader>
								<CardBody>
									<Row>
										<Col md="6">
											<FormGroup>
												<Label>{ t('Templates.AuctionDetail.TemplateName') }</Label>
												<Input
													className="form-control-sm"
													type="text"
													name="name"
													value={ templatesContext.auctionTemplate.name }
													onChange={ handleTemplatePropertyChange }
													valid={ templateSubmitted && templatesContext.auctionTemplate.validation.name }
													invalid={ templateSubmitted && !templatesContext.auctionTemplate.validation.name  }
												/>
											</FormGroup>
											
											<FormGroup check>
												<Label>
													<Input
														name="disabled"
														type="checkbox"
														checked={ templatesContext.auctionTemplate.disabled }
														onChange={ () => handleDisabledCheckboxChange(templatesContext.auctionTemplate.disabled) }
													/>  { t('Templates.AuctionDetail.Disabled') }
												</Label>
												{/*<label className="form-control-label" style={{ marginLeft: '3px' }}>{ t('Templates.AuctionDetail.Disabled') }</label>*/}
											</FormGroup>
										</Col>
										<Col md="6">
											<FormGroup>
												<Label>{ t('Templates.AuctionDetail.Default_For') }</Label>
												<Input
													type="select"
													name="defaultForTypeId"
													value={ templatesContext.auctionTemplate.defaultForTypeId }
													onChange={ handleTemplatePropertyChange }
												>
													{defaultSourceTypes !== undefined &&
														defaultSourceTypes.map((defaultSourceType, idx) => (
															<option value={ defaultSourceType.templateDefaultTypeId } key={ idx }>{ defaultSourceType.name }</option>
														))}
												</Input>
											</FormGroup>
											
											{
												(parseInt(templatesContext.auctionTemplate.defaultForTypeId) === parseInt(Enumeration.AuctionTemplateDefaultSourceTypes.Oem)) &&
												<FormGroup>
													<Label>{ t('Templates.AuctionDetail.Oem') }</Label>
													<Input
														type="select"
														name="defaultForEntityId"
														value={ templatesContext.auctionTemplate.defaultForEntityId }
														onChange={ handleTemplatePropertyChange }
													>
														{oems !== undefined &&
															oems.map((oem, idx) => (
																<option value={ oem.oemId } key={ idx }>{ oem.name }</option>
															))}
													</Input>
												</FormGroup>
											}
										</Col>
									</Row>
									<Row><Col md="12"><hr /></Col></Row>
									<Row>
										<Col md="6">
											<Row style={{ paddingBottom: '2px' }}>
												<Col md="6">
													<Label>{ t('Templates.AuctionDetail.Tiers_Header') }</Label>
												</Col>
												<Col md="6">
													<div className="text-right">
														<Button color="secondary" size="sm" onClick={ () => handleCreateNewTier() }>
															{ t('Templates.AuctionDetail.Tiers.Create_New') }
														</Button>
													</div>
												</Col>
											</Row>
											<Row>
												<Col md="12">
													<div className="tier-group">
														<div className="accordion">
															{
																templatesContext.auctionTemplate.auctionTemplateTiers.map((auctionTemplateTier, idx) => (
																	<Card
																		className="card-plain"
																		key={ idx }
																	>
																		<CardHeader role="tab">
																			<Button
																				block
																				color="link"
																				className="text-start m-0 p-0"
																				onClick={() => toggleTierCollapse(auctionTemplateTier.tierIndexPosition)}
																				aria-expanded={openedTierCollapse.includes(
																					auctionTemplateTier.tierIndexPosition
																				)}
																			>
																				<h5 className="m-0 p-0" style={{ fontSize: '12px', fontWeight: 'bolder' }}>{ auctionTemplateTier.name }</h5>
																			</Button>
																		</CardHeader>
																		<Collapse
																			role="tabpanel"
																			isOpen={openedTierCollapse.includes(auctionTemplateTier.tierIndexPosition)}
																		>
																			<CardBody>
																				<FormGroup>
																					<Label>{ t('Templates.AuctionDetail.Tiers.Tier_Name') }</Label>
																					<Input
																						type="text"
																						name="name"
																						value={ auctionTemplateTier.name }
																						onChange={
																							(ev) =>
																							{
																								handleTemplateTierPropertyChange(ev, auctionTemplateTier.adminAuctionTierId)
																							}
																						}
																						valid={ templateSubmitted && auctionTemplateTier.validation.name }
																						invalid={ templateSubmitted && !auctionTemplateTier.validation.name  }
																					/>
																				</FormGroup>
																				<FormGroup>
																					<Label>{ t('Templates.AuctionDetail.Tiers.Active_Duration_Hours') }</Label>
																					<Input
																						type="text"
																						name="activeDurationHours"
																						value={ auctionTemplateTier.activeDurationHours } // Per "Iteration rules.docx" - 	to start at 5PM EST 	to end at 3PM EST
																						disabled={ true }
																						onChange={
																							(ev) =>
																							{
																								handleTemplateTierPropertyChange(ev, auctionTemplateTier.adminAuctionTierId)
																							}
																						}
																						valid={ templateSubmitted && auctionTemplateTier.validation.activeDurationHours }
																						invalid={ templateSubmitted && !auctionTemplateTier.validation.activeDurationHours  }
																					/>
																				</FormGroup>
																				<FormGroup>
																					<Label>{ t('Templates.AuctionDetail.Tiers.Tier_State') }</Label>
																					<Input
																						type="select"
																						name="auctionTierStateId"
																						value={ auctionTemplateTier.auctionTierStateId }
																						onChange={
																							(ev) =>
																							{
																								handleTemplateTierPropertyChange(ev, auctionTemplateTier.adminAuctionTierId)
																							}
																						}
																						disabled={ auctionTemplateTier.isNew }
																					>
																						{auctionTierStates !== undefined &&
																							auctionTierStates.map((auctionTierState, idx) => (
																								<option value={ auctionTierState.auctionTierStateId } key={ idx }>
																									{ auctionTierState.name }
																								</option>
																							))}
																					</Input>
																				</FormGroup>
																				<FormGroup>
																					<Label>{ t('Templates.AuctionDetail.Tiers.Tier_Type') }</Label>
																					<Input
																						type="select"
																						name="auctionTierTypeId"
																						value={ auctionTemplateTier.auctionTierTypeId }
																						onChange={
																							(ev) =>
																							{
																								handleTemplateTierPropertyChange(ev, auctionTemplateTier.adminAuctionTierId)
																							}
																						}
																					>
																						{
																							auctionTierTypes !== undefined &&
																							auctionTierTypes.map((auctionTierType, idx) => (
																								<option value={ auctionTierType.auctionTierTypeId } key={ idx }>
																									{ auctionTierType.name }
																								</option>
																							))
																						}
																					</Input>
																				</FormGroup>
																				<FormGroup>
																					<Label>{ t('Templates.AuctionDetail.Tiers.Email_Template') }</Label>
																					<Input
																						type="select"
																						name="emailTemplateId"
																						value={ auctionTemplateTier.emailTemplateId }
																						onChange={
																							(ev) =>
																							{
																								handleTemplateTierPropertyChange(ev, auctionTemplateTier.adminAuctionTierId)
																							}
																						}
																					>
																						{
																							emailTemplates !== undefined &&
																							emailTemplates.map((emailTemplate, idx) => (
																								<option value={ emailTemplate.emailTemplateId } key={ idx }>
																									{ emailTemplate.templateName }
																								</option>
																							))
																						}
																					</Input>
																				</FormGroup>
																				<Row>
																					<Col md="12">
																						{
																							// Move Up = move tierIndexPosition closer to zero
																							((templatesContext.auctionTemplate.auctionTemplateTiers.length > 1) && (auctionTemplateTier.tierIndexPosition > 0)) ? (
																								<Button
																									color="secondary"
																									size="sm"
																									type="button"
																									onClick={ () => handleMoveTierUp(auctionTemplateTier) }
																									disabled={ auctionTemplateTier.isNew }
																									style={{ marginRight: '5px' }}
																								>
																									{ t('Templates.AuctionDetail.Tiers.Move_Up') }
																								</Button>
																							) : null
																						}
																						{
																							// Move Down = move tierIndexPosition away from zero
																							((templatesContext.auctionTemplate.auctionTemplateTiers.length > 1) && (auctionTemplateTier.tierIndexPosition < templatesContext.auctionTemplate.auctionTemplateTiers.length - 1)) ? (
																								<Button
																									color="secondary"
																									size="sm"
																									type="button"
																									onClick={ () => handleMoveTierDown(auctionTemplateTier) }
																									disabled={ auctionTemplateTier.isNew }
																									style={{ marginRight: '5px' }}
																								>
																									{ t('Templates.AuctionDetail.Tiers.Move_Down') }
																								</Button>
																							) : null
																						}
																						<Button
																							color="danger"
																							size="sm"
																							onClick={ () => handleRemoveTier(auctionTemplateTier) }
																						>
																							{ t('Templates.AuctionDetail.Tiers.Remove') }
																						</Button>
																					</Col>
																				</Row>
																			</CardBody>
																		</Collapse>
																	</Card>
																))
															}
														</div>
													</div>
												</Col>
											</Row>
										</Col>
										<Col md="6">
											<Row style={{ paddingBottom: '2px' }}>
												<Col md="6">
													<Label>{ t('Templates.AuctionDetail.Bidders_Header') }</Label>
												</Col>
												<Col md="6"></Col>
											</Row>
											<Row>
												<Col md="12">
													<div className="tier-group">
														{
															(activeTierMembers !== undefined) ? (
																<>
																	<Row style={{ paddingBottom: '2px' }}>
																		<Col md="12">
																			<div className="text-right">
																				<Button
																					color="secondary"
																					size="sm"
																					onClick={ () => handleAddExternalUser() }
																					style={{ marginLeft: '5px' }}
																				>
																					{ t('Templates.AuctionDetail.Tiers.Members.Add_External_User') }
																				</Button>
																				<Button
																					color="secondary"
																					size="sm"
																					onClick={ () => handleAddDealerUser() }
																					style={{ marginLeft: '5px' }}
																				>
																					{ t('Templates.AuctionDetail.Tiers.Members.Add_Dealer_User') }
																				</Button>
																			</div>
																		</Col>
																	</Row>
																	<Row>
																		<Col md="12">
																			<CardBody style={{ paddingLeft: '0px', paddingRight: '0px' }}>
																				{activeTierMembers.map((activeTierMember, idx) => (
																					(activeTierMember !== null) ? (
																						<ListGroup key={ idx } className="mt-3" flush>
																							<ListGroupItem className="px-0" style={{ padding: '0px' }}>
																								<Row className="align-items-center">
																									<Col className="col-auto">
																										<Button color="danger" size="sm" onClick={ () => handleRemoveTierMember(activeTierMember) }>
																											{ t('Templates.AuctionDetail.Tiers.Members.Remove_Member') }
																										</Button>
																									</Col>
																									<div className="col ml--2">
																										<h5 className="mb-0">{ activeTierMember.fullName }</h5>
																									</div>
																									<Col className="col-auto">
																										<h5 className="checklist-title mb-0">{ activeTierMember.usersAffiliation || (activeTierMember.dealerName + ' - ' + activeTierMember.oemName) }</h5>
																									</Col>
																								</Row>
																							</ListGroupItem>
																						</ListGroup>
																					) : undefined
																				))}
																			</CardBody>
																		</Col>
																	</Row>
																</>
															) : (
																<Row>
																	<Col md="12" style={{ textAlign: 'center' }}>
																		<label className="form-control-label" >{ t('Templates.AuctionDetail.Tiers.Members.Select_Auction_Tier') }</label>
																	</Col>
																</Row>
															)
														}
													</div>
												</Col>
											</Row>
										</Col>
									</Row>
									<Row>
										<Col md="6">
											<Button block className="btn-block" color="danger" size="lg" onClick={ handleConfirmTemplateDelete } style={{ 'marginTop': '30px' }}>
												{ t('Templates.AuctionDetail.Delete_Template') }
											</Button>
										</Col>
										<Col md="6">
											<Button block className="btn-block" color="primary" size="lg" onClick={ handleSaveTemplate } style={{ 'marginTop': '30px' }}>
												{ t('Templates.AuctionDetail.Save_Template') }
											</Button>
										</Col>
									</Row>
								</CardBody>
								<CardFooter></CardFooter>
							</Card>
						</Form>
					</div>
				</Row>
			</Container>

			<SelectExternalUserModalRedux
				showExternalUserModal={ showExternalUserModal }
				exclusionList={ exclusionList }
				activeTierMembers={ activeTierMembers }
				tierId={ (activeTier !== undefined) ? activeTier.adminAuctionTierId : 0 }
			/>
			
			<SelectDealerUserModalRedux
				showDealerUserModal={ showDealerUserModal }
				exclusionList={ exclusionList }
				activeTierMembers={ activeTierMembers }
				tierId={ (activeTier !== undefined) ? activeTier.adminAuctionTierId : 0 }
			>
			</SelectDealerUserModalRedux>
			
			<Modal
				className="modal-dialog-centered"
				isOpen={ openConfirmTemplateDeleteModal }
				toggle={ () => setOpenConfirmTemplateDeleteModal(false) }
			>
				<div className="modal-body p-0">
					<Card className="bg-secondary border-0 mb-0">
						<CardHeader>
							<div className="modal-header">
								<h6 className="modal-title" id="modal-title-default">
									<h3 className="mb-0">{ t('Templates.AuctionDetail.Delete_Template') }</h3>
								</h6>
								<button
									aria-label="Close"
									className="close"
									data-dismiss="modal"
									type="button"
									onClick={() => setOpenConfirmTemplateDeleteModal(false)}
								>
									<span aria-hidden={true}>×</span>
								</button>
							</div>
						</CardHeader>
						<CardBody>
							<div className="modal-body"><p>{t('Templates.AuctionDetail.Confirm_Deletion_Message')}</p></div>
						</CardBody>
						<CardFooter>
							<Row>
								<Col md={6}>
									<Button color="default" type="button" className="btn-block" onClick={ () => setOpenConfirmTemplateDeleteModal(false) }>
										{ t('Common.No') }
									</Button>
								</Col>
								<Col md={6}>
									<Button color="primary" type="button" className="btn-block" onClick={ handleDeleteTemplate }>
										{ t('Common.Yes') }
									</Button>
								</Col>
							</Row>
						</CardFooter>
					</Card>
				</div>
			</Modal>
			
			<Modal
				className="modal-dialog-centered"
				isOpen={ openMissingTierTypeModal }
				toggle={ () => setOpenMissingTierTypeModal(false) }
			>
				<div className="modal-body p-0">
					<Card className="bg-secondary border-0 mb-0">
						<CardHeader>
							<div className="modal-header">
								<h6 className="modal-title" id="modal-title-default">
									<h3 className="mb-0">{ t('Templates.AuctionDetail.Missing_Tier_Type') }</h3>
								</h6>
								<button
									aria-label="Close"
									className="close"
									data-dismiss="modal"
									type="button"
									onClick={ () => setOpenMissingTierTypeModal(false) }
								>
									<span aria-hidden={true}>×</span>
								</button>
							</div>
						</CardHeader>
						<CardBody>
							<div className="modal-body"><p>{ t('Templates.AuctionDetail.Missing_Tier_Message') }</p></div>
						</CardBody>
						<CardFooter>
							<Row>
								<Col md={6}>
									<Button color="default" type="button" className="btn-block" onClick={ () => setOpenMissingTierTypeModal(false) }>
										{ t('Common.Cancel') }
									</Button>
								</Col>
								<Col md={6}>
									<Button color="primary" type="button" className="btn-block" onClick={ () => finallySaveTemplate() }>
										{ t('Common.Okay') }
									</Button>
								</Col>
							</Row>
						</CardFooter>
					</Card>
				</div>
			</Modal>
		</>
	)
}

export default AuctionTemplateDetail
